import React from 'react';
import SignupSuccess from '../SignupSuccess';
import Checkout from '../Checkout';
import ChangePassword from '../ChangePassword';
import ResetPassword from '../ResetPassword';
import TrackPackage from '../TrackPackage';
import CheckOutSuccess from '../CheckOutSuccess';
import AdyenPayment from '../AdyenPayment';
import { history } from '../../store';
import MobileHeaderSidenav from '../Layout/Header/MobileHeader';
import DefaultDashboardBody from './DefaultDashboardBody';

const createReactClass = require('create-react-class');
const Dashboard = createReactClass({

  componentWillMount() {
    this.props.getCMSList();
    const token = localStorage.jwtToken;
    //this.props.signedIn(token);
    // this.props.getParcel(token);
    this.props.getWarehouse();
    this.props.getProhibitedParcel(token);
    this.props.getCopyrightYear();
    this.props.getCartData();

    if (!localStorage.jwtToken && this.props.location.pathname !== "/reset-password" && this.props.location.pathname !== "/change-password" && this.props.location.pathname !== "/track-package") {
      history.push("/signin");
    }
    this.props.getGeneralSettings(token);

  },
  getInitialState: function () {
    return {
      tooltipText: {
        "name": false,
        "address": false,
        "city": false,
        "state": false,
        "zip": false,
        "tel": false,
      },
      cmsList: [],
      footerLinks: ["2", "3", "4", "7",],
      bottomNavLinks: ["1", "5", "6",],
      bottomNavLinksClass: ["first about pull-left", "second terms pull-left", "third privacy pull-left",],
    }
    
  },
  handleLogout() {
    localStorage.removeItem('jwtToken');
    this.props.resetSignUp();
    this.props.logout();
  },
  handleMouseEnter(e) {
    var targ = e.target || e.srcElement;
    if (targ.tagName === "TD") {
      var str = this.state.tooltipText;
      str[targ.getAttribute('data-name')] = false;
      this.setState({
        tooltipText: str,
      });
    }
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      cmsList: nextProps.cms.getCmsList ? nextProps.cms.CmsList.data : [],
    });

    if (!localStorage.jwtToken && !nextProps.location.pathname === "/reset-password" && !nextProps.location.pathname === "/change-password" && !nextProps.location.pathname === "/track-package") {
      history.push("/signin");
    }
  },

  componentWillUnmount() {
    if (localStorage.trackPackage2) { localStorage.removeItem("trackPackage2"); }
  },
  renderDashboardBody(){
    let body = null;
    switch(this.props.location.pathname.toLowerCase()){
      case "/reset-password":
        body = (<div><ResetPassword {...this.props} /></div>);
        break;
      case "/change-password":
        body = (<div><ChangePassword {...this.props} /></div>);
        break;
      case "/signup-success":
        body = (<div><SignupSuccess {...this.props} /></div>);
        break;
      case "/checkout-success":
        body = (<div><CheckOutSuccess {...this.props} /></div>);
        break;
      case "/checkout":
        body = (<div><Checkout {...this.props} /></div>);
        break;
      case "/track-package":
        body = (<div><TrackPackage {...this.props} /></div>);
        break;
      case "/adyen-payment":
          body = (<div><AdyenPayment {...this.props} /></div>);
          break;
      default:
        body = (<DefaultDashboardBody {...this.props}/>);
    }

    return body;
  },
  render() {
    
    return (
      <div>
        <MobileHeaderSidenav
          isAuthenticated={true}
          login={this.props.login}
          isSideNavOpen={false}
          logout={this.handleLogout}
        />
        {this.renderDashboardBody()}
      </div>
    )
  },
});

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/Dashboard.js
 **/